import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UIActionModal } from "../../../../ui";

const ReactivateRequestModal = ({
  open,
  applicants,
  copy,
  onClose,
  onConfirm,
}) => {
  const isBulk = applicants.length > 1;
  const primaryApplicant = applicants[0];
  const title = isBulk ? copy.bulkTitle : copy.singleTitle;
  const bulkMessage = copy.bulkMessage.replace("{count}", applicants.length);

  return (
    <UIActionModal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="sm"
      PaperProps={{ className: "event-applicants-reactivate-modal" }}
      actions={
        <UIActionModal.Actions
          cancelLabel={copy.cancel}
          confirmLabel={copy.confirm}
          onCancel={onClose}
          onConfirm={onConfirm}
        />
      }
    >
      <UIActionModal.Divider />
      {isBulk ? (
        <Typography className="ui-action-modal__body-text">{bulkMessage}</Typography>
      ) : (
        <Typography className="ui-action-modal__body-text">
          {copy.singleMessageBefore}
          <strong>{primaryApplicant?.name}</strong>
          {copy.singleMessageAfter}
        </Typography>
      )}
    </UIActionModal>
  );
};
ReactivateRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  applicants: PropTypes.arrayOf(PropTypes.object),
  copy: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ReactivateRequestModal.defaultProps = {
  applicants: [],
};

export default ReactivateRequestModal;
